<template>
  <div class="input-query-main">
    <Dropdown :style="{width: showDesc ? '50%' : '100%', marginBottom: '4px'}" :placeholder="placeholder" :items="privateItems" :itemKey="itemKey" :selectedObject.sync="privateSelectedObject"
      :isDisabled="isDisabled" :isRequired="isRequired" :errorMessage.sync="privateErrorMessage" :allowFreeText="allowFreeText" :search.sync="dropdownText"
      :validator="validator" :validatorFunction="validatorFunction"
      @selected="itemSelected" @focusChanged="focusChanged" @keydown="dropdownKeydown" ref="dropdown" />
    <button class="query-btn" @click="showTable = true" :disabled="isDisabled" tabindex="-1" title="Open Table (Ctrl + Q)">
      <img :src="`https://dsmlib.logistics.systems/Icons/${addLink || canRefresh ? 'MagnifyingGlassAdditional' : 'MagnifyingGlass'}.png`">
      <div v-if="isDisabled" class="query-disabled"></div>
    </button>
    <div v-if="showDesc" class="desc" :title="privateSelectedObject == null ? '' : privateSelectedObject[descKey]">{{ privateSelectedObject == null ? '' : privateSelectedObject[descKey] }}</div>

    <div v-if="showTable" class="table-popup">
      <div v-if="showRowLimit" class="row-limit-container">
        <div class="row-limit-input">
          <Input :inputValue.sync="privateRowLimitInputValue" :placeholder="rowLimitPlaceHolder" :isRequired="rowLimitIsRequired" :errorMessage.sync="privateRowLimitErrorMessage" validator="positiveInteger" @focusChanged="rowLimitFocusChanged" />
        </div>
      </div>
      <div class="content">
        <TableBox :tableData="privateItems" :title="`Search ${placeholder}`" :maxSelection="0" :dataType="tableBoxDataType" :stickColumn="[0]"
          :additionalButtons="[{ text: 'Select', index: 0, width: 75 }]" @buttonClicked="tableButtonClicked" :hideColumns="tableBoxHideColumns" />
        <div class="button-container">
          <button v-if="addLink" @click="addRecordClicked" style="color: green">Add Record</button>
          <button v-if="canRefresh" @click="refreshRecordClicked" style="color: blue">Refresh Record</button>
          <button style="color: red" @click="closeTableClicked">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data: function() {
    return {
      privateItems: [],
      privateSelectedObject: null,
      privateErrorMessage: '',
      showTable: false,
      dropdownText: '',
      privateRowLimitInputValue: "",
      privateRowLimitErrorMessage: "",
    };
  },
  props: {
    items: { type: Array, default: function() { return []; } }, // The items that will be populated in the dropdown and the tablebox
    itemKey: { type: String, default: '' }, // The key of the items to show in the dropdown
    showDesc: { type: Boolean, default: false }, // Set to true to reserve some space next to the magnifying glass for a description of the selected object
    descKey: { type: String, default: '' }, // The key of the items to show as the description at the right side of the query button

    placeholder: { type: String, default: 'Items' }, // The placeholder of the dropdown, also the title of the tablebox
    selectedObject: { type: Object, default: function() { return null; } },
    isDisabled: { type: Boolean, default: false }, // Set as true, and the user will not be able to select or type in the input query
    isRequired: { type: Boolean, default: false }, // Set this to true to indicate this input query is required
    errorMessage: { type: String, default: '' }, // Set the error message of the inputQuery
    allowFreeText: { type: Boolean, default: false }, // Set to false to make sure that users select items within the list only
    search: { type: String, default: '' }, // Get the value of the input
    validator: { type: String, default: '' }, // validator for input value, refer to input component for the list of available validators
    validatorFunction: { type: Function, default: null }, // custom validator function for input value, refer to input component for the function signature

    addLink: { type: String, default: '' },
    canRefresh: { type: Boolean, default: false },
    tableBoxDataType: { type: Object, default: function() { return {}; } }, // Set the data type of the TableBox shown when clicking on the magnifying glass
    tableBoxHideColumns: { type: Array, default: function() { return []; } }, // Columns to hide in the table box
    showRowLimit: { type: Boolean, default: false }, // show or hide the row limit input when the magnifying glass is clicked
    rowLimitPlaceHolder: { type: String, default: 'No. of Rows Shown' }, // placeholder for the row limit input
    rowLimitInputValue: { type: String, default: '' }, // input value for the row limit input (use .sync)
    rowLimitIsRequired: { type: Boolean, default: false }, // set row limit input as required or not
    rowLimitErrorMessage: { type: String, default: '' }, // error message for the row limit input (use .sync)

    // Public events
    // @selected(newSelectedValue: Object | null, oldSelectedValue: Object | null) - fired when an item is selected by the user, returns the newly selected item and the previous, will not fire if value is changed programatically
    // @focusChanged(focus: Boolean) - fired when the input focused is changed, returns true if the input is focused
    // @refreshClicked(placeholder: String) - fired when refresh record button is clicked, returns the placeholder
    // @rowLimitFocusChanged(focus: Boolean, placeholder: String) - fired when the row limit input is either focused on or focused out of
  },
  methods: {
    focusChanged: function(focused) {
      this.$emit('focusChanged', focused);
    },
    dropdownKeydown: function(keyboardEvent) {
      if (keyboardEvent.ctrlKey && keyboardEvent.key.toUpperCase() === 'Q') {
        this.showTable = true;
        this.dropdownText = this.privateSelectedObject?.[this.itemKey] ?? "";
        this.$nextTick(() => {
          this.setBlur();
        });
      }
    },
    tableButtonClicked: function(_text, data) {
      this.privateSelectedObject = data;
      this.$emit('update:selectedObject', data);
      this.$emit('update:search', data[this.itemKey]);
      this.$emit('selected', data, this.selectedObject);
      this.showTable = false;
      this.privateErrorMessage = ""; // the watcher will emit an event to update the prop
    },
    itemSelected: function(newObject, oldObject) {
      this.privateSelectedObject = newObject;
      this.$emit('update:selectedObject', newObject);
      this.$emit('update:search', newObject?.[this.itemKey] ?? this.dropdownText); // if free text is selected, newObject will be null
      this.$emit('selected', newObject, oldObject);
    },
    // eslint-disable-next-line vue/no-unused-properties -- public method used by pages that call this component, just not used within this component
    setFocus: function() { // public method
      this.$refs.dropdown.setFocus();
    },
    setBlur: function() { // public method, but also used within this component
      this.$refs.dropdown.setBlur();
    },

    closeTableClicked: async function() {
      this.showTable = false;
    },
    escapeCloseTable: function(keyboardEvent) {
      if (keyboardEvent.code === 'Escape') {
        this.closeTableClicked();
      }
    },

    addRecordClicked: function() {
      const currentUser = this.$route.params['user'];
      const routeSplit = this.addLink.split('/').filter(r => r);
      if (routeSplit[0].toLowerCase() == 'home' && currentUser) {
        routeSplit.splice(1, 0, currentUser);
      }
      const route = this.$router.resolve(`/${routeSplit.join('/')}`);
      window.open(route.href, '_blank');
    },
    refreshRecordClicked: async function() {
      this.$emit("refreshClicked", this.placeholder);
    },

    rowLimitFocusChanged: function(focus) {
      this.$emit("rowLimitFocusChanged", focus, this.placeholder);
    },
  },
  mounted() {
    if (this.errorMessage) {
      this.privateErrorMessage = this.errorMessage;
    }
    
    if (this.selectedObject) {
      this.privateSelectedObject = this.selectedObject;
    } else {
      this.dropdownText = this.search;
    }

    if (this.items) {
      this.privateItems = this.items;
    }

    if (this.rowLimitInputValue) {
      this.privateRowLimitInputValue = this.rowLimitInputValue;
    }

    if (this.rowLimitErrorMessage) {
      this.privateRowLimitErrorMessage = this.rowLimitErrorMessage;
    }
  },
  watch: {
    selectedObject: function(val) {
      this.privateSelectedObject = val;
      if (val) {
        this.dropdownText = val[this.itemKey];
        this.$emit('update:search', val[this.itemKey]);
      }
    },
    errorMessage: function(val) {
      this.privateErrorMessage = val;
    },
    items: function(val) {
      this.privateItems = val;
    },
    privateErrorMessage: function(val) {
      this.$emit('update:errorMessage', val);
    },
    showTable: function(val) {
      if (val) {
        document.addEventListener('keydown', this.escapeCloseTable);
      } else {
        document.removeEventListener('keydown', this.escapeCloseTable);
      }
    },
    search: function(val) {
      this.dropdownText = val;
    },
    rowLimitInputValue: function(val) {
      this.privateRowLimitInputValue = val;
    },
    privateRowLimitInputValue: function(val) {
      this.$emit('update:rowLimitInputValue', val);
    },
    rowLimitErrorMessage: function(val) {
      this.privateRowLimitErrorMessage = val;
    },
    privateRowLimitErrorMessage: function(val) {
      this.$emit('update:rowLimitErrorMessage', val);
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.input-query-main {
  display: flex;
  width: 100%;
  align-items: center;
  height: 25px;
  padding: 0;
  margin: 2px 0px;
  position: relative;
  // border: 1px solid black;
  
  > .popup-loading {
    background-color: rgba(0, 0, 0, 0.1);
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }
}

.query-btn {
  background-color: transparent;
  // border: 1px solid rgba(128,128,128,1);
  border: none;
  border-radius: 5px;
  padding: 0 2px;
  width: fit-content;
  margin: 0 2px;
  height: 15px;
  font-weight: bolder;
  display: flex;
  position: relative;
  top: -3px;

  > img {
    height: 15px;
  }

  .dots {
    width: 2px;
    height: 2px;
    margin: 0 1px;
    background-color: black;
    border-radius: 100%;
  }

  .query-disabled {
    position: absolute;
    opacity: 0.8;
    background-color: rgba(200,200,200,0.3);
    top: -5px;
    left: -3px;
    height: 24px;
    width: 25px;
  }
}

.query-btn:focus {
  outline: none;
  box-shadow: none;
}

.desc {
  width: 50%;
  margin-left: 5px;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.table-popup {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.3);
  padding: 10px;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 115;
  padding-top: calc(#{$top-nav-height} + 10px);

  > .row-limit-container {
    width: 90%;
    margin-bottom: 5px;
    display: flex;
    justify-content: flex-end;

    > .row-limit-input {
      border-radius: 5px;
      padding: 5px 5px 0;
      background-color: white;
      width: 20%
    }
  }

  > .content {
    position: relative;
    background-color: white;
    width: 90%;
    padding: 10px;
    border-radius: 5px;
    height: 70%;

    > .button-container {
      position: absolute;
      top: 100%;
      right: 10px;
      margin: 0 3px;
      width: fit-content;

      > button {
        background-color: white;
        border-radius: 0;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;

        &:not(:last-child) {
          margin-right: 5px;
        }

        &:last-child {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>